var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillRule: "nonzero",
    d: "M19.166 2.25H5.01L4.707.682C4.63.286 4.287 0 3.889 0H.417C.187 0 0 .189 0 .422v.844c0 .233.187.421.417.421h2.786l2.416 12.506c-.383.404-.619.952-.619 1.557C5 16.993 5.995 18 7.222 18c1.228 0 2.222-1.007 2.222-2.25 0-.395-.102-.783-.298-1.125h5.04c-.195.342-.298.73-.297 1.125 0 1.243.995 2.25 2.222 2.25 1.227 0 2.222-1.007 2.222-2.25 0-.638-.262-1.213-.683-1.622l.036-.167c.113-.526-.283-1.024-.814-1.024H7.075l-.326-1.687h10.847c.392 0 .731-.277.815-.665l1.57-7.312c.113-.526-.283-1.023-.815-1.023zM7.222 16.594c-.46 0-.833-.379-.833-.844 0-.465.374-.844.833-.844.46 0 .834.379.834.844 0 .465-.374.844-.834.844zm8.89 0c-.46 0-.834-.379-.834-.844 0-.465.374-.844.833-.844.46 0 .833.379.833.844 0 .465-.373.844-.833.844zm.813-7.032H6.423L5.336 3.939h12.797l-1.208 5.624z",
    transform: "translate(-377 -557) translate(40 554) translate(335) translate(2 3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H24V24H0z",
    transform: "translate(-377 -557) translate(40 554) translate(335)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.6cfc7dc5.svg";
export { ForwardRef as ReactComponent };